var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#FFB53F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.0755 10H27.4615C28.8637 10 30 11.1459 30 12.56V15.9745C30 17.3886 28.8637 18.5345 27.4615 18.5345H24.0755C22.6732 18.5345 21.537 17.3886 21.537 15.9745V12.56C21.537 11.1459 22.6732 10 24.0755 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9245 21.4655C17.3268 21.4655 18.463 22.6114 18.463 24.0255V27.44C18.463 28.8532 17.3268 30 15.9245 30H12.5385C11.1363 30 10 28.8532 10 27.44V24.0255C10 22.6114 11.1363 21.4655 12.5385 21.4655H15.9245ZM27.4615 21.4655C28.8637 21.4655 30 22.6114 30 24.0255V27.44C30 28.8532 28.8637 30 27.4615 30H24.0755C22.6732 30 21.537 28.8532 21.537 27.44V24.0255C21.537 22.6114 22.6732 21.4655 24.0755 21.4655H27.4615ZM15.9245 10C17.3268 10 18.463 11.1459 18.463 12.56V15.9745C18.463 17.3886 17.3268 18.5345 15.9245 18.5345H12.5385C11.1363 18.5345 10 17.3886 10 15.9745V12.56C10 11.1459 11.1363 10 12.5385 10H15.9245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.6d358a15d20ae09957eeaee8eb0cff1a.svg";
export { ForwardRef as ReactComponent };